import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * Get the brands
 *
 * @returns {object} the result data
 */
export default async function getBrands () {
  return await fetchJSONData(
    `${constants.API_URL}/partners/front/all?network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    }
  )
}
